
<div class="flex-container main-page-loader" *ngIf="showPhpLoader">
  <div class="flex-centered">
     <div class="flex-column loader-position">
        <div class="loader flex-centered" id="loader-1">
           <div class="brand-wrapper flex-container">
            <img src="assets/images/doh-logo-white.svg"  class="flex-centered">
           </div>
        </div>
     </div>
  </div>
</div>

<div *ngIf="!showPhpLoader" class="min-vh-100 d-flex flex-row align-items-center login" style="position: relative;">
  <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="default" color="#0099a8" type="cube-transition"
    [fullScreen]="false" template='<div class="indicator">
  <svg width="16px" height="12px">
    <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
    <polyline
      id="front"
      points="1 6 4 6 6 11 10 1 12 6 15 6"
    ></polyline>
  </svg>
</div>'></ngx-spinner>
  <c-container>
    <div class="doh-bracket">
      <img src="../../../../assets/images/DOH-logo.svg" alt="" />
    </div>
    <c-row class="justify-content-center">
      <c-col md="8">
        <c-card-group>
          <c-card class="py-3 px-3 login-card">
            <c-card-body>
              <form cForm>
                <div class="form-child">
                  <div class="uae-pass-logo">
                    <h5 class="mb-1">For Non-DOH Users Sign In with</h5>
                    <div class="fingerprint-wrap">
                      <img class="mt-2" style="width: 300px" src="../../../../assets/images/UAE-pass.png" alt="" />
                    </div>
                  </div>
                  <div class="arbi-button" (click)="loginUAEPass()">
                    <!-- <div class="arbi-button" (click)="onLogin('uaepass')"> -->
                    <a>
                      <img class="mt-2" style="width: 300px" src="../../../../assets/images/DOH-PH-Login-btn.png"
                        alt="" />
                    </a>
                  </div>
                </div>
              </form>
            </c-card-body>
          </c-card>
          <c-card class="text-white py-3 register-card">
            <c-card-body class="text-center">
              <div class="doh-brand-logo">
                <img src="../../../../assets/img/brand/signin-logo.png" alt="Doh brand" />
              </div>
              <div>
                <!-- <button [active]="true" cButton class="mt-4" color="primary"  (click)="onLogin('doh')">
                  Sign In as DOH User
                </button> -->
                <!-- <button cButton class="mt-4" color="primary" (click)="loginModal()" > Sign In as DOH User </button> -->
                <button cButton class="mt-4 ms-3" color="primary" (click)="loginRedirect()"> Sign In as DOH User
                </button>
              </div>
            </c-card-body>
          </c-card>
          <button class="registerBtn" (click)="registerButton()">
            <a>
              Register or Link Account
            </a>
          </button>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>

<div class="success-modal-form" *ngIf="showRoles">
    <div class="animation-text-wrapper">
      <div class="animation-wrapper">
        <div class="animation-text-wrapper">
          <form [formGroup]="rolesForm" (submit)="submitRole()">
            <div class="form-group">
          <h5>Please Select A Role...</h5>
          <div [cFormFloating]="true" class="mb-3">
            <select formControlName="roleControl" cSelect>
              <option selected disabled>Please Select</option>
              <option *ngFor="let item of facilityMemberProfile.facilityMemberRole; let i = index"
                value="{{item.key}}">
                {{item.value}}
              </option>
            </select>
            <label cLabel>Roles</label>
          </div>
        </div>
        <button type="submit" class="submitBtn">Submit</button>
      </form>
          <!-- <form [formGroup]="dohLoginForm">
            <div class="form-group">
              <input type="email" id="dohEmail" cFormControl placeholder="Email " formControlName="dohEmail" />
              <span class="text-danger" *ngIf="!this.dohLoginForm.valid && dohLoginForm?.get('dohEmail')?.touched">Please
                enter a valid email address. </span>
            </div>
          </form> -->
          <!-- <div class="login-btn-wrapper mt-2">
            <button (click)="onLogin('doh', '')" class="submitBtn">Login</button>
            <button (click)="closeLoginPopup()" class="submitBtn">Exit</button>
          </div> -->
        </div>
      </div>
</div>
<div class="error-modal-form" *ngIf="emiratesIdPopUp">
  <div class="animation-wrapper">
    <div class="animation-text-wrapper">
      <div class="animation-view">
        <img src="../../assets/images/error-animation.gif" alt="" />
      </div>
      <div class="animation-text-wrapper">
        <h5>Failure</h5>
        <p>{{errorMessage}}</p>
        <p>{{errorMessageArabic}}</p>
        <button (click)="closeLoginPopup()" class="submitBtn">Try Again</button>
      </div>
    </div>
  </div>
</div>

<div class="error-modal-form" *ngIf="dohLogPopUp">
  <div class="animation-wrapper">
    <div class="animation-text-wrapper">
      <h5>Please Verify Email Address</h5>
      <form [formGroup]="dohLoginForm">
        <div class="form-group">
          <input type="email" id="dohEmail" cFormControl placeholder="Email " formControlName="dohEmail" />
          <span class="text-danger" *ngIf="!this.dohLoginForm.valid && dohLoginForm?.get('dohEmail')?.touched">Please
            enter a valid email address. </span>
        </div>
      </form>
      <div class="login-btn-wrapper mt-2">
        <button (click)="onLogin('doh', '')" class="submitBtn">Login</button>
        <button (click)="closeLoginPopup()" class="submitBtn">Exit</button>
      </div>
    </div>
  </div>
</div>

<div class="authenticate-modal" *ngIf="authenticateErrorModal">
  <div class="authenticate-modal-body">
    <div class="error-modal-form">
      <div class="animation-wrapper">
        <div class="animation-view">
          <img src="../../assets/images/error-animation.gif" alt="" />
        </div>

        <div class="animation-text-wrapper">
          <h5>Error!</h5>
          <p>{{this.MSALError}}</p>
          <button (click)="authenticateReset()" class="submitBtn">Proceed</button>
        </div>
      </div>
    </div>
  </div>
</div>